import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { ModuleGuard, P, PFull, PNoHeader } from '@/app/guards';
import {
  ArdoisesBar,
  CheckIn,
  FloorPlan,
  GuestRegister,
  HotelRooms,
  Kiosque,
  KitchenDisplay,
  OrderTracker,
  SalleDisplay,
  TableSession,
  TogoImprimantes,
  TogoMateriel,
  TogoTPE,
  TogoTickets,
  WaiterPad,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function foodChrRoutes() {
  return (
    <>
      {/* Cuisine / KDS + Affichage salle */}
      <Route
        path="/cuisine"
        element={
          <PFull>
            <ModuleGuard modules={['mod_cuisine_kds']}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <KitchenDisplay />
                </Suspense>
              </ErrorBoundary>
            </ModuleGuard>
          </PFull>
        }
      />
      <Route
        path="/salle-display"
        element={
          <PFull>
            <ModuleGuard modules={['mod_restaurant_salle']}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <SalleDisplay />
                </Suspense>
              </ErrorBoundary>
            </ModuleGuard>
          </PFull>
        }
      />

      {/* Togo */}
      <Route
        path="/togo/imprimantes"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TogoImprimantes />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/togo/tickets"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TogoTickets />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/togo/tpe"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TogoTPE />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/togo/materiel"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TogoMateriel />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />

      {/* CHR — Restaurant */}
      <Route
        path="/chr/salle"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FloorPlan />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/chr/table/:sessionId"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TableSession />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/chr/serveur"
        element={
          <PNoHeader>
            <ModuleGuard modules={['mod_tablette_serveur']}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <WaiterPad />
                </Suspense>
              </ErrorBoundary>
            </ModuleGuard>
          </PNoHeader>
        }
      />
      <Route
        path="/kiosque"
        element={
          <PFull>
            <ModuleGuard modules={['mod_kiosque']}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <Kiosque />
                </Suspense>
              </ErrorBoundary>
            </ModuleGuard>
          </PFull>
        }
      />
      <Route
        path="/commandes"
        element={
          <PFull>
            <ModuleGuard modules={['mod_cuisine_kds', 'mod_kiosque', 'mod_restaurant_salle']}>
              <Suspense fallback={<LoadingSpinner />}>
                <OrderTracker />
              </Suspense>
            </ModuleGuard>
          </PFull>
        }
      />

      {/* CHR — Hôtel */}
      <Route
        path="/chr/chambres"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <HotelRooms />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/chr/checkin/:roomId"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CheckIn />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/chr/sejour/:stayId"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CheckIn />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/chr/voyageurs"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <GuestRegister />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />

      {/* CHR — Bar */}
      <Route
        path="/chr/bar"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ArdoisesBar />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
    </>
  );
}
